import { Component, OnInit } from '@angular/core';
import { CrossoverService } from 'src/app/services/crossover.service';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-analisi',
  standalone: true,
  templateUrl: './analisi.component.html',
  styleUrls: ['./analisi.component.scss'],
  imports: [HighchartsChartModule, MdbFormsModule, MdbSelectModule,
    MdbTableModule, CommonModule
  ]
})
export class AnalisiComponent implements OnInit {

  tableData: any = []
  headers = ['market', 'punti', 'profit euro', 'operazioni', 'punti op', 'perc pos', 'media pos', 'media neg', 'rawal', 'max DD']

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}

  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false


  constructor(private service: CrossoverService) { }

  ngOnInit(): void {
    this.service.lista().subscribe((data: any) => {
      if (data.res == 'ok') {
        let dd = data.dati
        this.tableData = dd
      }
    })
  }

  openChart(market: string) {
    this.service.market(market).subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        this.aggiornaGrafico(market, data.dati)
      }
    })
  }

  aggiornaGrafico(mkt: string, dati: any[]) {
    let p = 0;
    let progr = dati.map((a: any) => {
      p += +a.profit
      return p
    })
    let pm = 0
    let pMax = 0
    progr.map((a: any) => {
      pm = a > pm ? a : pm
      pMax = (pm - a) > pMax ? (pm - a) : pMax
    })
    let mk = this.tableData.find((el: any) => el.market == mkt)
    mk.maxdd = pMax
    this.chartOptions = {
      title: {
        text: mkt
      },
      series: [{
        data: progr,
        type: 'line'
      }
      ]
    }
  }

}
